export { RandomGThumbnail, generateDefaultThumb } from './random-g-thumbnail'
